module.exports = __webpack_public_path__ + "img/Component 69 – 55.48754a6d.svg";